<template>
	<div class="sign-in-button-wrapper">
		<ClientOnly>
			<DefaultButton
				:ctaLink="ctaLink"
				:icon="ctaIcon"
				:color="ctaColor"
				:gtm="ctaGtm"
				:aria-label="ctaAriaLabel"
				v-on="!isLoggedIn ? { 'button-click': signUserIn } : {}"
			></DefaultButton>
		</ClientOnly>
	</div>
</template>

<script setup>
const config = useRuntimeConfig();
const props = defineProps({
	fields: { type: Object, required: false },
	rendering: { type: Object, required: false },
});

const store = useAppStore();
const localePath = useLocalePath();

const ctaLink = computed(() => {
	if (isLoggedIn.value) {
		return {
			text: signedInLabel.value,
			url: localePath(config.public.myAccountUrl),
		};
	} else {
		return props.fields?.ctaLink?.value;
	}
});

const ctaIcon = computed(() => props.fields?.ctaIcon?.value);
const ctaColor = computed(() => props.fields?.ctaColor?.value);
const ctaGtm = computed(() => props.fields?.ctaGtm?.value);
const ctaAriaLabel = computed(() => props.fields?.ctaAriaLabel?.value);
const signedInLabel = computed(() => props.fields?.signedInLabel?.value);

const msal = useMsalStore();
const { session } = useUserSession();

const isLoggedIn = computed(() => {
	return session.value?.isFound === false || session.value.user;
});

async function signUserIn() {
	try {
		store.setLoading(true);
		await msal.signIn();

		if (session.value?.isFound) {
			await navigateTo(localePath(config.public.myAccountUrl));
		} else {
			await navigateTo(localePath(config.public.completeProfileUrl));
		}

		store.setLoading(false);
	} catch (e) {
		store.setLoading(false);
	}
}
</script>
<style lang="scss">
.sign-in-button-wrapper {
	width: 100%;
	display: flex;

	.cta-btn {
		width: 100%;
		margin: var(--spacing-2, 16px);
	}
}
</style>
